import { render, staticRenderFns } from "./UserAuth.vue?vue&type=template&id=492c6f4a&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"
import style0 from "./UserAuth.vue?vue&type=style&index=0&id=492c6f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c6f4a",
  null
  
)

export default component.exports